// http://157.175.90.166:8080

import HTTPOcr from "./http_ocr.service";
import HTTP from "../services/http.service";

import Helpers from "../helpers/shared.helper";
import Settings from "../services/settings.service";
import Storage from "../services/storage.service";

var OcrService = {};

OcrService.checkImages = (data, onUploadProgress = null) => {
	Helpers.debug_payment("OCR check", data);

	let config = {
		method: "post",
		url: "/api/process",
		data: data,
		onUploadProgress: onUploadProgress
	};
	return HTTPOcr(config);
};
OcrService.sendOcrData = (data) => {
	Helpers.debug_payment("OCR check", data);
	let config = {
		method: "post",
		url: "/user_identy/ocr_data",
		data: data,
	};
	return HTTP(config);
};
OcrService.sendOcrImages = (data) => {
	Helpers.debug_payment("OCR check", data);
	let config = {
		method: "post",
		url: "/user_identy/ocr_images",
		data: data,
		// params: data
	};
	return HTTP(config);
};
OcrService.sendOcrAddress = (data) => {
	Helpers.debug_payment("OCR check", data);
	let config = {
		method: "post",
		url: "/user_identy/submit_address",
		data: data,
		// params: data
	};
	return HTTP(config);
};
OcrService.sendSignature = (data) => {
	Helpers.debug_payment("OCR check", data);
	let config = {
		method: "post",
		url: "/user_identy/ocr_signature",
		data: data,
	};
	return HTTP(config);
};

OcrService.getGovernoratesAreas = () => {

	Helpers.debug_payment("OCR get_governorates_areas",);
	let config = {
		method: "get",
		url: "/user_identy/get_governorates_areas",
	};
	return HTTP(config);
}


OcrService.convertBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const fileReader = new FileReader();
		fileReader.readAsDataURL(file);

		fileReader.onload = () => {
			resolve(fileReader.result);
		};

		fileReader.onerror = (error) => {
			reject(error);
		};
	});
};
OcrService.proccessGovernoratesAreas = (data, area_code = null) => {
	if (data && area_code) {
		let area = null;
		let governorate_id = null;
		for (const areaObj of data) {
			for (const [, value] of Object.entries(areaObj.Areas)) {
				if (value.Code + "" === area_code + "") {
					area = value.Name;
					governorate_id = areaObj.Code
					return { area: area, governorate_id: governorate_id };
				}
			}
		}
	}
	return {};
}

OcrService.proccessImagesData = (data, type, setBedoonType = () => { }) => {
	let ListVerifiedFields = [];
	let dType = null;
	let overallStatus = true;
	let bedoonType = false;
	let BedoonIdNumber = null;

	if (
		data?.ContainerList &&
		data?.ContainerList?.List &&
		data?.ContainerList?.List.length !== 0
	) {
		for (let item in data.ContainerList.List) {
			if (data.ContainerList.List[item]?.Status?.overallStatus === 0) overallStatus = false;
			if (data.ContainerList.List[item].DocVisualExtendedInfo) {
				ListVerifiedFields = ListVerifiedFields.concat(data.ContainerList.List[item].DocVisualExtendedInfo.pArrayFields);
				if (data.ContainerList.List[item].DocVisualExtendedInfo.pArrayFields.length) {
					BedoonIdNumber = data.ContainerList.List[item].DocVisualExtendedInfo.pArrayFields.find((ele) =>
						ele.FieldName === "Document Number");
				}
			}
			if (data.ContainerList.List[item].ListVerifiedFields) {
				ListVerifiedFields = ListVerifiedFields.concat(data.ContainerList.List[item].ListVerifiedFields.pFieldMaps);
			}
			if (data.ContainerList.List[item].OneCandidate && data.ContainerList.List[item].OneCandidate.FDSIDList && !dType) {
				dType = data.ContainerList.List[item].OneCandidate.FDSIDList.dType;
			}
			if (data.ContainerList.List[item].OneCandidate &&
				data.ContainerList.List[item].OneCandidate.FDSIDList.dCountryName === "Kuwait" &&
				data.ContainerList.List[item].OneCandidate.DocumentName.includes("Bidoon")) {
				bedoonType = true;
				setBedoonType(true);
			}
		}
	}

	if (ListVerifiedFields.length === 0) return { ...Settings["ocr_fields_" + type] };
	let ocrFields = Settings.get("ocr_fields_" + type);
	let generatedObject = {}
	for (const item of Object.keys(ocrFields)) {
		generatedObject = {
			...generatedObject,
			[item]: { ...ocrFields[item] }
		}
	}

	for (let item in ListVerifiedFields) {
		let fieldType = ListVerifiedFields[item].wFieldType;
		let newfieldType = ListVerifiedFields[item].FieldType;
		let wLCID = ListVerifiedFields[item].wLCID;
		if (generatedObject[fieldType] && generatedObject[fieldType].value === "") {
			let value = "";
			const fieldDate = (fieldType === 5 || fieldType === 3);
			if (ListVerifiedFields[item].Buf_Text) {
				if (fieldType !== 25 && fieldType !== 7) {
					value = ListVerifiedFields[item].Buf_Text;
				}
			} else {
				if (fieldType === 25 && wLCID !== 0) continue
				value = ListVerifiedFields[item].Field_Visual
				if (fieldDate && value?.split("-").length !== 3 && ListVerifiedFields[item].Field_MRZ) {
					value = ListVerifiedFields[item].Field_MRZ;
				}
			}

			if (fieldDate && value?.split("-").length !== 3)
				value = "";
			generatedObject[fieldType].value =
				// (value && !value.includes("?")) 
				value
					? value : "";
			generatedObject[fieldType].valid = OcrService.checkFieldValidity(generatedObject[fieldType].value, generatedObject[fieldType].validations);
			if (generatedObject[fieldType].name === "gender" && generatedObject[fieldType].value !== "") {
				generatedObject[fieldType].value = generatedObject[fieldType].value === "M" ? 1 : 2;
			}
		}
		if (newfieldType === 7 && ListVerifiedFields[item].Field_Visual) {
			let value = ""
			value = ListVerifiedFields[item].Field_Visual;
			generatedObject[newfieldType].value =
				value
					? value : "";
			generatedObject[newfieldType].valid = OcrService.checkFieldValidity(generatedObject[newfieldType].value, generatedObject[newfieldType].validations);
		}
	}
	if (generatedObject["7"] && generatedObject["7"].value === "" && generatedObject["2"] && generatedObject["2"].value !== "") {
		generatedObject["7"].value = generatedObject["2"].value;
		generatedObject["7"].valid = OcrService.checkFieldValidity(generatedObject["2"].value, generatedObject["7"].validations);
	}
	if (dType) {
		let gcc_iso_code = "";
		if (generatedObject["26"] && generatedObject["26"].value !== "") {
			gcc_iso_code = generatedObject["26"].value
		}

		const value = OcrService.mappedDtypeToInt(dType, bedoonType ? "bedoon_type" : generatedObject["35"].type, gcc_iso_code);
		if (value === -1) {
			generatedObject["35"].valid = false;
			return { ...Settings["ocr_fields_" + type] };
		}
		generatedObject["35"].valid = true;
		generatedObject["35"].value = value;
	} else {
		generatedObject["35"].value = "";
		generatedObject["35"].valid = false;
	}
	// check full names
	if (generatedObject["25"].value !== "") {
		const fullNames = generatedObject["25"].value.split(" ");
		const fullNamesLength = fullNames.length;
		if (fullNamesLength === 1) {
			if (generatedObject["9"].value === "")
				generatedObject["9"].value = fullNames[0];
		} else if (fullNamesLength === 2) {
			if (generatedObject["9"].value === "")
				generatedObject["9"].value = fullNames[0];
			if (generatedObject["8"].value === "")
				generatedObject["8"].value = fullNames[1];
		} else if (fullNamesLength === 3) {
			generatedObject["9"].value = fullNames[0];
			generatedObject["91"] = {
				value: fullNames[1],
				name: "second_name",
				valid: true,
				show: false,
				data_submition: true
			};
			generatedObject["92"] = {
				value: "",
				name: "third_name",
				valid: true,
				show: false,
				data_submition: true
			}
			generatedObject["8"].value = fullNames[2];
		} else if (fullNamesLength >= 4) {
			generatedObject["9"].value = fullNames[0];
			generatedObject["91"] = {
				value: fullNames[1],
				name: "second_name",
				valid: true,
				show: false,
				data_submition: true
			};
			generatedObject["92"] = {
				value: fullNames[2],
				name: "third_name",
				valid: true,
				show: false,
				data_submition: true
			}
			generatedObject["8"].value = fullNames.slice(3).join(" ");
		}
	}
	if (bedoonType) {
		if (generatedObject["7"].value === "") {
			if (BedoonIdNumber?.Buf_Text?.length) {
				generatedObject["7"].value = BedoonIdNumber.Buf_Text;
				generatedObject["7"].valid = true;
			}
		}

		generatedObject["26"].validations = { required: false }
		generatedObject["26"].valid = true;
		generatedObject["12"].validations = { required: false }
		generatedObject["12"].valid = true;
	}
	generatedObject["overallStatus"] = overallStatus;

	return generatedObject;

}

OcrService.checkFieldValidity = (value, validations) => {

	if (validations.required && value.trim() === "") return false;
	if (validations.expiry) {
		let todayDate = Date.parse(new Date().toUTCString());
		let expiryDateFormat = value.split("-");
		if (expiryDateFormat.length !== 3) return false;
		let expiryDate = Date.parse(new Date(+expiryDateFormat[0], +expiryDateFormat[1] - 1, +expiryDateFormat[2]).toUTCString());
		if (expiryDate < todayDate) {
			return false;
		}
	}
	if (validations.minAge) {
		let todayDate = new Date(new Date().toUTCString());
		let birthDateFormat = value.split("-");
		if (birthDateFormat.length !== 3) return false;
		let birthDate = new Date(new Date(+birthDateFormat[0], +birthDateFormat[1] - 1, +birthDateFormat[2]).toUTCString());
		let currentYear = todayDate.getUTCFullYear();
		let currentMonth = todayDate.getUTCMonth();
		let currentDay = todayDate.getUTCDate();
		let birthYear = birthDate.getUTCFullYear();
		let birthMonth = birthDate.getUTCMonth();
		let birthDay = birthDate.getUTCDate();
		if ((currentYear - birthYear) <= validations.minAge) {
			if (currentMonth <= birthMonth) {
				if (currentMonth === birthMonth) {
					if (currentDay < birthDay) return false
				} else
					return false
			} else
				return false
		}

	}

	if (validations.minLength && ((value + "").trim().length < validations.minLength))
		return false;

	if (validations.maxLength && ((value + "").trim().length > validations.maxLength))
		return false;

	if (validations.numberOnly && !(/^\d+$/.test(value)) && value.trim() !== "")
		return false
	return true;

}

OcrService.mappedDtypeToInt = (dType, type, iso_code) => {
	const gcc_iso_codes = JSON.parse(Storage.get("business", true))[
		"web_gcc_iso_code"] ? JSON.parse(Storage.get("business", true))[
	"web_gcc_iso_code"] : [];
	if (dType === 12 && type === "kw_passport_gcc" && gcc_iso_codes.includes(iso_code)) {
		return 3
	}
	//For passport
	if (dType === 11 && type === "kw_passport_gcc") return 2;
	//For kuwait
	if ((dType === 12 || dType === 15) && type === "kw_id") return 1;
	//For GCC
	if ((dType === 224 || dType === 152 || dType === 173) && type === "kw_passport_gcc") return 3;
	if (dType === 12 && type === "bedoon_type") return 4;
	return -1;
}

export default OcrService;
